export default "__VITE_ASSET__CBU1_grX__"